import { WidgetType } from "@uiw/react-codemirror";
export class MarkdownMarkerWidget extends WidgetType {
    constructor(text, className) {
        super();
        this.text = text;
        this.className = className;
    }
    eq(widget) {
        return widget instanceof MarkdownMarkerWidget
            && widget.text === this.text
            && widget.className === this.className;
    }
    toDOM() {
        const element = document.createElement("span");
        element.className = this.className;
        element.textContent = this.text;
        return element;
    }
}
